var map = {
	"./1.png": 9843,
	"./2.png": 7473,
	"./3.png": 7732,
	"./4.png": 8309,
	"./5.png": 6457,
	"./6.png": 7630,
	"./7.png": 5228,
	"./8.png": 2847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6560;